// extracted by mini-css-extract-plugin
export default {"root":"Modal-root-d56f","close":"Modal-close-f1c0","background":"Modal-background-eb08"};